export const PREPARE_NEW_ORDER_MODAL_OPEN = 'PREPARE_NEW_ORDER_MODAL_OPEN';
export const prepareToOpenNewOrderModal = () => {
  return {
    type: PREPARE_NEW_ORDER_MODAL_OPEN,
  };
};

export const NEW_ORDER_MODAL_OPEN = 'NEW_ORDER_MODAL_OPEN';
export const openNewOrderModal = (salesOrder, workflowGuid) => {
  return {
    type: NEW_ORDER_MODAL_OPEN,
    salesOrder,
    workflowGuid,
  };
};

export const NEW_ORDER_MODAL_CLOSED = 'NEW_ORDER_MODAL_CLOSED';
export const closedNewOrderModal = (hasMadeChanges, workflowGuid) => {
  return {
    type: NEW_ORDER_MODAL_CLOSED,
    hasMadeChanges,
    workflowGuid,
  };
};

export const NEW_ORDER_MODAL_HAS_MADE_CHANGES = 'NEW_ORDER_MODAL_HAS_MADE_CHANGES';
export const newOrderModalHasMadeChanges = () => {
  return {
    type: NEW_ORDER_MODAL_HAS_MADE_CHANGES,
  };
};

export const CANCEL_BULK_ORDER_MODAL_OPEN = 'CANCEL_BULK_ORDER_MODAL_OPEN';
export const openBulkCancelModal = (shouldShowPendingFulfillmentText = false) => {
  return {
    type: CANCEL_BULK_ORDER_MODAL_OPEN,
    shouldShowPendingFulfillmentText,
  };
};
